"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const TableSchemaContext = react_1.default.createContext({
    tablesList: [],
    applicationsList: [],
    loading: false,
});
exports.TableSchemaContext = TableSchemaContext;
//# sourceMappingURL=TableSchemaContext.js.map